import { makeStyles } from 'makeStyles';
import { BACKGROUND_GREY, BORDERS_GREY, TEXT_DEFAULT } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  accordionRoot: {
    border: BORDERS_GREY,
    borderRadius: 5,
    boxShadow: 'none',
    marginBottom: `20px!important`,
    '&::before': {
      content: 'none',
    },
    '& > div': {
      '& > div': {
        margin: `0!important`,
      },
    },
  },
  accordionSummary: {
    backgroundColor: '#001436',
    '& .MuiAccordionSummary-expandIconWrapper, .MuiTypography-root, .MuiIconButton-root': {
      color: 'white',
    },
    '& .MuiAccordionSummary-content': {
      gap: '10px',
      alignItems: 'center',
    },
    padding: theme.spacing(2, 3),
    '@media print': {
      backgroundColor: 'white',
      '& .MuiTypography-root': {
        color: TEXT_DEFAULT,
      },
    },
  },
  accordionSecondary: {
    backgroundColor: BACKGROUND_GREY,
    '& .MuiAccordionSummary-expandIconWrapper, .MuiTypography-root, .MuiIconButton-root': {
      color: TEXT_DEFAULT,
    },
  },
  accordionSummaryDetails: {
    paddingBottom: 0,
    '.Mui-expanded &': {
      display: TEXT_DEFAULT,
    },
  },
}));
